module.exports = __webpack_public_path__ + "assets/images/ant1.494e15dc96642f55c109669470bd302e.png";